var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E9D689"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4673 25L15.3113 21.192H14.3873V25H12.4273V15.228H16.0953C16.8513 15.228 17.4953 15.3633 18.0273 15.634C18.5593 15.8953 18.9559 16.2547 19.2173 16.712C19.4879 17.16 19.6233 17.664 19.6233 18.224C19.6233 18.868 19.4366 19.4513 19.0633 19.974C18.6899 20.4873 18.1346 20.842 17.3973 21.038L19.7353 25H17.4673ZM14.3873 19.722H16.0253C16.5573 19.722 16.9539 19.596 17.2153 19.344C17.4766 19.0827 17.6073 18.7233 17.6073 18.266C17.6073 17.818 17.4766 17.4727 17.2153 17.23C16.9539 16.978 16.5573 16.852 16.0253 16.852H14.3873V19.722ZM26.576 25L24.42 21.192H23.496V25H21.536V15.228H25.204C25.96 15.228 26.604 15.3633 27.136 15.634C27.668 15.8953 28.0647 16.2547 28.326 16.712C28.5967 17.16 28.732 17.664 28.732 18.224C28.732 18.868 28.5453 19.4513 28.172 19.974C27.7987 20.4873 27.2433 20.842 26.506 21.038L28.844 25H26.576ZM23.496 19.722H25.134C25.666 19.722 26.0627 19.596 26.324 19.344C26.5853 19.0827 26.716 18.7233 26.716 18.266C26.716 17.818 26.5853 17.4727 26.324 17.23C26.0627 16.978 25.666 16.852 25.134 16.852H23.496V19.722Z",
    fill: "#E9D689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee2);
export default __webpack_public_path__ + "static/media/employee2.0d00b944aa0ae35a873caf44a22b696c.svg";
export { ForwardRef as ReactComponent };